import { React, PT } from '@gasbuddy/react';
import { Segment, Input, Button } from 'semantic-ui-react';
import { Nav } from '../../components';

export class EnterEmail extends React.Component {
  componentDidMount() {
    this.emailBox.focus();
  }

  setEmail = (event) => {
    this.setState({ email: event.target.value });
  }

  keyPress = (e) => {
    if (e.key === 'Enter') {
      this.go();
    }
  }

  go = () => {
    const { history } = this.props;
    const { email } = this.state;
    history.push(
      `/identity/admin/${email}`,
    );
  };

  render() {
    return (
      <Nav>
        <Segment>
          <Input
            fluid
            action
            ref={(input) => { this.emailBox = input; }}
            placeholder="Enter Email Address"
            onChange={this.setEmail}
            onKeyPress={this.keyPress}
          >
            <input />
            <Button onClick={this.go}>Search</Button>
          </Input>
        </Segment>
      </Nav>
    );
  }
}

EnterEmail.propTypes = {
  history: PT.shape({ push: PT.func }).isRequired,
};
